var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('TagList',{attrs:{"items":_vm.tags,"isLinks":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }